var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"panel card"},[_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"panel-header mb-4"},[_c('h1',{staticClass:"h3"},[_vm._v("广告合作 ")])]),_c('div',{staticClass:"panel-body mt-2"},[_c('p',[_vm._v("如有合作意向，请添加QQ:3467926156联系站长沟通。")])])])])
}]

export { render, staticRenderFns }